module.exports = "static/assets/37954fe300d44f8765b6d48b2836fcf5.png";